import { render, staticRenderFns } from "./InformationRiskArea.vue?vue&type=template&id=21e20db5&scoped=true"
import script from "./InformationRiskArea.vue?vue&type=script&lang=js"
export * from "./InformationRiskArea.vue?vue&type=script&lang=js"
import style0 from "./InformationRiskArea.vue?vue&type=style&index=0&id=21e20db5&prod&scoped=true&lang=css"
import style1 from "./InformationRiskArea.vue?vue&type=style&index=1&id=21e20db5&prod&lang=css"
import style2 from "./InformationRiskArea.vue?vue&type=style&index=2&id=21e20db5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e20db5",
  null
  
)

export default component.exports